import { Button, DatePicker, Icon, message } from 'antd'
import {
  DatePickerContext,
  ErrorContext,
  JcTmpErrorContext,
  SpinContext,
} from 'context'
import {
  getAmlificationCode,
  getApiTargetInfo,
  getCauseCodeMap,
  getClientInfo,
  getEnvConfig,
  getFailCode,
  getPermitActions,
  getUnitCodeCauseCodeMapList,
  getUnitNameMap,
  getUnits,
  getUtilities,
  getUtilityNameMap,
  isAdminType,
  isUnitLoading,
} from 'core'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  getCauseCodeAll,
  getDailyUnitViewDetails,
  getSystemConfigurationInfo,
} from 'api/pgads'
import TmpCard97, { headers as tempCard97Headers } from './component/TmpCard97'
import DailyEventTypeDescription from './component/DailyEventTypeDescription'
import DailyEventHoverDetails from './component/DailyEventHoverDetails'
import { headers as card97headers } from 'card-data/Card97Antd'
import Card97EditPrompt from 'card-data/component/card97/Card97EditAntd'
import DailyGraph2 from './component/DailyGraph2'
import moment from 'moment'
import ExportComponents from 'core/component/ExportComponent'
import { UtilityUnitSelection } from '../core'
import DailyUnitViewData, {
  getformattedValueBy1decimal,
} from './component/DailyUnitViewData'

const UnitDailyView = ({
  targetInfo,
  units,
  unitNameMap,
  // utilitys,
  utilityNameMap,
  envConfig,
  actionPermits,
  CLIENT,
  ...props
}) => {
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const card97Ref = useRef()
  const getDefaultStateData = _ => ({ card97: [], graphData: [], tmpError: [] })
  const [data, setData] = useState(getDefaultStateData)

  const [selectedUtility, setSelectedUtility] = useState()
  const [selectedUnit, setSelectedUnit] = useState()

  const onCriteriaChange = _ => setData(getDefaultStateData())

  const [card97Dominant, setCard97Dominant] = useState(false)

  const [cardEditPromptRowData, setCardEditPromptRowData] = useState({})
  const [cardEditPrompt, setCardEditPrompt] = useState(false)
  const [cardEditPromptMode, setCardEditPromptMode] = useState('V')
  const [selectedEventNum, setSelectedEventNum] = useState(0)

  const [graphSelBar, setGraphSelBar] = useState([])
  const [unitCodeMap, setUnitCodeMap] = useState({})
  const [unitShortNameMap, setUnitShortNameMap] = useState({})
  const [timeZoneMap, setTimeZoneMap] = useState({})
  const [rectHoverData, setRectHoverData] = useState({})

  const [causeCodeList, setCauseCodeList] = useState([])
  useEffect(
    _ => {
      getCauseCodeAll(targetInfo).fork(setError, setCauseCodeList)
    },
    [setError, targetInfo]
  )
  // const [hoursWidth, setHoursWidth] = useState(10)

  useEffect(() => {
    getSystemConfigurationInfo(targetInfo).fork(setError, d => {
      const dominantData = d.filter(
        s => s.key === 'DOMINANT_DERATE' && s.value === 'YES'
      )
      setCard97Dominant(dominantData.length > 0)
    })
  }, [setError, targetInfo])

  // const [utility, setUtility] = useState(
  //   (selectedUnits[0] || {}).utility || units[0].utility
  // )
  // const [unit, setUnit] = useState(
  //   (selectedUnits[0] || {}).unitId || units[0].unitId
  // )

  const getDomValue = useCallback(
    (ioCode, eventType, utility, unit) => {
      /*
         if (rs.getString("IOCODE") != null && rs.getString("IOCODE").trim().length() > 0) {
                iocode = Integer.parseInt(rs.getString("IOCODE"));
                if ((ruleSet.equalsIgnoreCase("MISO") || ruleSet.equalsIgnoreCase("NERC")) &&
                        (eventType$.equalsIgnoreCase("D1") || eventType$.equalsIgnoreCase("D2") || eventType$.equalsIgnoreCase("D3") ||
                                eventType$.equalsIgnoreCase("D4") || eventType$.equalsIgnoreCase("PD"))) {
                    if (iocode == 0)
                        dominant = "N";
                    else if (iocode == -1)
                        dominant = "Y";
                    else
                        dominant = "na";
                } else
                    dominant = "na";

            } else
                dominant = "na";
    */
      if (ioCode === undefined || ioCode == null || ioCode.trim().length <= 0)
        return 'na'
      else {
        const matchedUnit = units.find(
          u => u.utility === utility && u.unit === unit
        )
        const ruleSet = matchedUnit && matchedUnit.ruleSet
        if (
          (ruleSet === 'MISO' || ruleSet === 'NERC') &&
          ['D1', 'D2', 'D3', 'D4', 'PD'].includes(eventType)
        ) {
          const ioVal = parseInt(ioCode)
          if (ioVal === 0) return 'N'
          else if (ioVal === -1) return 'Y'
        }
      }
      return 'na'
    },
    [units]
  )

  useEffect(() => {
    setTimeZoneMap(timeZoneList(units))
    setUnitCodeMap(unitCodeList(units))
    setUnitShortNameMap(unitShortNameList(units))
  }, [units])

  // const utilitySelectionList = useMemo(
  //   _ => {
  //     const ut = R.compose(
  //       R.sortBy(R.prop('utilityName')),
  //       R.filter(u => !!u),
  //       R.map(u => (utilitys || []).find(ut => ut.utility === u)),
  //       R.uniq,
  //       R.map(u => u.utility)
  //     )(units || [])

  //     return ut
  //   },
  //   [units, utilitys]
  // )

  const onRetrieve = ({ date = selectedDate }) => {
    if (!selectedUtility || selectedUtility.length <= 0) {
      message.info('Please, Select Utility/Unit')
      return
    }
    setSpinning(true)

    const req = {
      date: date.format('YYYY-MM-DD'),
      utility: selectedUtility,
      unit: selectedUnit.substring(3),
    }
    getDailyUnitViewDetails(targetInfo)(req).fork(setError, data => {
      setSpinning(false)
      const { graphData, card97, tmpDailyData } = data
      const nd = card97
        .map(d => ({
          ...d,
          shortName: unitShortNameMap[d.unitId] || d.unitId,
          dom: getDomValue(d.ioCode, d.eventType, d.utility, d.unit),
        }))
        .filter(f => f.unitId === selectedUnit)
      const graphDatafilter = graphData.filter(f => f.unitId === selectedUnit)
      const dailyUnitData = tmpDailyData.filter(f => f.unitId === selectedUnit)

      setData({
        graphData: graphDatafilter,
        card97: nd,
        tmpDailyData: formatUnitDailyData(dailyUnitData),
      })
      if (data.tmpError) {
        setTmpError(data.tmpError)
      }
    })
  }

  const formatUnitDailyData = data => {
    return data.map(d => {
      const {
        utility,
        unit,
        unitId,
        transdate,
        label,
        keyLabel,
        seq,
        total,
        ...rest
      } = d

      R.range(1, 26).forEach(hrKey => {
        const hrVal = rest['hr' + hrKey]
        rest['hr' + hrKey] = getformattedValueBy1decimal(hrVal)
      })

      const final = {
        utility,
        unit,
        unitId,
        transdate,
        label,
        keyLabel,
        seq,
        total,
        ...rest,
      }

      return final
    })
  }
  useEffect(() => {
    if (card97Ref.current) {
      const num = card97Ref.current
        .generateViewProps()
        .view.findIndex(
          d =>
            d.eventIdx === '1' &&
            parseInt(d.eventNum) === parseInt(graphSelBar.eventNum) &&
            (d.unitId === graphSelBar.unitId || d.unit === graphSelBar.unit)
        )
      // const num = tmpcard97.findIndex(
      //   d => d.eventIdx === '1' && d.eventNum == graphSelBar.eventNum
      // )
      if (card97Ref.current !== undefined && num >= 0)
        card97Ref.current.setSelectedRect({ y1: num, y2: num, x1: 1, x2: 3 })
    }
  }, [graphSelBar])

  const setFastRevind = eventStart => {
    const date = moment(eventStart)
    if (!(date.format('YYYY-MM-DD') === selectedDate.format('YYYY-MM-DD'))) {
      setSelectedDate(date)
      onRetrieve({ date })
    } else {
      message.info('Same Date ')
    }
  }

  const exportHeaders = useMemo(
    _ => {
      return tempCard97Headers(200, CLIENT, true)
    },
    [CLIENT]
  )
  const [xBandWidth, setXBandsWidth] = useState(35)

  const unitCodeCauseCodeMap = useMemo(
    _ => getUnitCodeCauseCodeMapList(causeCodeList),
    [causeCodeList]
  )

  return (
    <div>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'min-content auto',
        }}
      >
        <CriteriaRow>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                '220px 70px 200px 110px 300px 100px 200px auto 150px auto 150px',
              width: '100%',
              gap: '5px',
            }}
          >
            <Title>Daily Unit View</Title>
            <div
              style={{
                display: 'grid',
                justifyContent: 'end',
                alignContent: 'center',
              }}
            >
              Date :
            </div>
            <DatePicker
              style={{ width: '100%' }}
              allowClear={false}
              format="MMM/DD/YYYY"
              value={selectedDate}
              onChange={d => {
                setSelectedDate(d)
                onCriteriaChange()
              }}
            />
            <div
              style={{
                display: 'grid',
                justifyContent: 'end',
                alignContent: 'center',
              }}
            >
              Select Unit :
            </div>
            <UtilityUnitSelection
              utility={selectedUtility}
              unit={selectedUnit}
              onUnitChange={value => {
                setSelectedUtility(value[0])
                setSelectedUnit(value[1])
              }}
              casStyle={{ marginLeft: '5px' }}
            />

            <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
              <Button
                style={{ marginLeft: '10px' }}
                type="primary"
                onClick={() => {
                  const dt = selectedDate.clone().subtract(1, 'd')
                  setSelectedDate(dt)
                  // setIsRetrieved(false)
                  onRetrieve({ date: dt })
                }}
                loading={spinning}
              >
                <Icon type="left" />
              </Button>

              <Button
                style={{}}
                type="primary"
                onClick={() => {
                  const dt = selectedDate.clone().add(1, 'd')
                  setSelectedDate(dt)
                  // setIsRetrieved(false)
                  onRetrieve({ date: dt })
                  // setSelectedDate(selectedDate.clone().add(1, 'd'))
                  // setIsRetrieved(false)
                }}
                loading={spinning}
              >
                <Icon type="right" />
              </Button>
            </Button.Group>

            <Button
              onClick={onRetrieve}
              style={{ marginLeft: '10px' }}
              type="primary"
              icon="database"
              loading={spinning}
            >
              Retrieve
            </Button>
            <Filler />
            <Button type="danger" icon="save">
              Save
            </Button>
            <Filler />

            <ExportComponents
              data={(data.card97 || []).filter(d => parseInt(d.eventIdx) === 1)}
              headers={(exportHeaders || []).map(d => ({
                ...d,
                rowHeaderBackgroundColor: '#eee',
              }))}
              fileName="Daily View"
              btnStyle={{ marginRight: '10px' }}
              disabled={(data.card97 || []).length <= 0}
            />
          </div>
        </CriteriaRow>
        {/* <Divider style={{ marginTop: '5px' }} /> */}
        <Content>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '70% 30%',
              gridTemplateRows: '300px auto',
              gap: '10px',
            }}
          >
            <FullHeightSizer heightOffset={270}>
              {({ width }) => (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: 'min-content auto',
                  }}
                >
                  <DailyGraph2
                    setFastRevind={setFastRevind}
                    selectedEventNum={selectedEventNum}
                    setGraphSelBar={setGraphSelBar}
                    graphSelBar={graphSelBar}
                    setRectHoverData={setRectHoverData}
                    data={data}
                    unitShortNameMap={unitShortNameMap}
                    totalWidth={width}
                    forceHeight={50}
                    height={150}
                    envConfig={envConfig}
                    actionPermits={actionPermits}
                    setCardEditPromptMode={setCardEditPromptMode}
                    setCardEditPromptRowData={setCardEditPromptRowData}
                    setCardEditPrompt={setCardEditPrompt}
                    selectedDate={selectedDate}
                    setXBandsWidth={setXBandsWidth}
                    svgDivStyle={{ overflow: 'hidden' }}
                    showGraphHeaders={false}
                  />
                  <DailyUnitViewData
                    data={data.tmpDailyData}
                    columnSize={xBandWidth}
                  />
                </div>
              )}
            </FullHeightSizer>
            <div
              style={{
                display: 'grid',
                gridTemplateRows: '60% 40%',
                rowGap: '10px',
              }}
            >
              <DailyEventTypeDescription height={200} />
              <DailyEventHoverDetails data={rectHoverData} height={100} />
            </div>
            <div style={{ gridColumnEnd: 'span 2', marginTop: '5px' }}>
              <FullHeightSizer heightOffset={500}>
                {({ height, width }) => (
                  <TmpCard97
                    showShortName
                    CLIENT={CLIENT}
                    cref={card97Ref}
                    setCardEditPromptRowData={setCardEditPromptRowData}
                    setCardEditPrompt={setCardEditPrompt}
                    setCardEditPromptMode={setCardEditPromptMode}
                    style={{ gridColumnGap: 'span 2' }}
                    retrieveData={_ => onRetrieve()}
                    data={(data.card97 || [])
                      .filter(d => d.eventIdx === '1')
                      .map(d => ({
                        ...d,
                        causeDescription:
                          props.causeCodeMap[d.causeCode] || d.causeCode || '',
                      }))}
                    unitNameMap={unitNameMap}
                    utilityNameMap={utilityNameMap}
                    date={selectedDate}
                    selUtility={selectedUtility}
                    // selUnit={unit === undefined ? '' : unit}
                    idxData={(data.card97 || []).filter(
                      d => d.eventIdx !== '1'
                    )}
                    ampCodeMap={props.ampCodeMap}
                    failCodeMap={props.failCodeMap}
                    unitCodeMap={unitCodeMap}
                    unitShortNameMap={unitShortNameMap}
                    causeCodeMap={props.causeCodeMap}
                    card97Dominant={card97Dominant}
                    targetInfo={targetInfo}
                    timeZoneMap={timeZoneMap}
                    monthlyGraphRectSelection={{}}
                    screenSize={{
                      width,
                      height: height - 80 < 0 ? 100 : height - 80,
                      // height: 3,
                    }}
                    unitList={units}
                    graphSelBar={graphSelBar}
                    utility={selectedUtility}
                    // unit={unit}
                    selectedMonthYear={selectedDate}
                    lock="U"
                    hoursWidth={60}
                    setSelectedEventNum={setSelectedEventNum}
                    envConfig={envConfig}
                    actionPermits={actionPermits}
                    causeCodeList={causeCodeList}
                  />
                )}
              </FullHeightSizer>
            </div>
          </div>
        </Content>
      </div>

      {cardEditPrompt && (
        <Card97EditPrompt
          CLIENT={CLIENT}
          key="card97editpromptq"
          mode={cardEditPromptMode}
          apiTargetInfo={targetInfo}
          setPrompt={setCardEditPrompt}
          rowData={cardEditPromptRowData}
          utilityNameMap={utilityNameMap}
          unitNameMap={unitNameMap}
          criteriaYear={selectedDate.format('YYYY')}
          // utility={utility}
          // unit={unit}
          // setPromptMsg={this.setPromptMsg}
          timeZoneMap={timeZoneMap}
          card97Dominant={card97Dominant}
          unitsList={units}
          ampCodeMap={props.ampCodeMap}
          failCodeMap={props.failCodeMap}
          unitCodeMap={unitCodeMap}
          unitShortNameMap={unitShortNameMap}
          idxData={
            cardEditPromptMode === 'N'
              ? []
              : (data.card97 || []).filter(
                  d =>
                    d.eventNum === cardEditPromptRowData.eventNum &&
                    d.eventIdx !== '1'
                )
          }
          causeCodeMap={props.causeCodeMap}
          setEditPromptvisible={setCardEditPrompt}
          promptEdit={cardEditPrompt}
          headers={card97headers}
          retrieveData={onRetrieve}
          causeCodeList={causeCodeList}
          unitCodeCauseCodeMap={unitCodeCauseCodeMap}
          allowRetrieve
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  units: getUnits(state),
  unitNameMap: getUnitNameMap(state),
  utilitys: getUtilities(state),
  utilityNameMap: getUtilityNameMap(state),
  causeCodeMap: getCauseCodeMap(state),
  unitLoading: isUnitLoading(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  ampCodeMap: getAmlificationCode(state),
  failCode: getFailCode(state),
  isAdminType: isAdminType(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(UnitDailyView)

const timeZoneList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.timeZone])
)

const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.id1])
)

const unitShortNameList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.shortName])
)
